module.exports = __webpack_public_path__ + "static/media/chevron-left.09ead17d.svg";